/** @jsxImportSource @emotion/react */
import { css } from "@emotion/react";
import styled from "@emotion/styled";
import React, { useState } from "react";

import { standardLabels } from "../../styles/labels";
import { ILabelColors } from "../../types/LabelTypes";

const Container = styled.div`
  width: 100%;

  display: flex;
  align-items: center;
  justify-content: start;

  > div + div {
    margin-left: 16px;
  }
`;

const LabelButton = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;

  width: 20px;
  height: 20px;

  border-radius: 50%;
  border: 1px solid;

  cursor: pointer;

  &:hover {
    opacity: 0.8;
  }
`;

const Icon = styled.img`
  width: 12px;
  height: 12px;
`;

interface Props {
  labelColorsNotAvailable?: string[];
  handleLabelChecked: (value: string, index: number) => void;
  labelChecked: string | undefined;
  checkedLabelIndex: number;
}
export default function Labels(props: Props): JSX.Element {
  const {
    handleLabelChecked,
    labelChecked,
    checkedLabelIndex,
    labelColorsNotAvailable,
  } = props;
  const [labelColors] = useState<ILabelColors[]>(standardLabels);

  return (
    <Container>
      {labelColors
        .filter((lab) => !labelColorsNotAvailable?.includes(lab.color))
        .map((elem) => {
          return (
            <LabelButton
              key={`label_button_${elem.color}`}
              css={css`
                background-color: ${elem.color};
                border-color: ${elem.borderColor};
              `}
              onClick={() => handleLabelChecked(elem.color, checkedLabelIndex)}
            >
              {labelChecked === elem.color && (
                <Icon src={"./icons/check.svg"} />
              )}
            </LabelButton>
          );
        })}
    </Container>
  );
}
